import React, { Component } from 'react';
import { Alert, Box, Container, Grid, IconButton, Table, TableBody, TableCell, TableRow, Typography } from '@mui/material';
import { SIDES } from '../../Admin/Equipements/Single/EquipementDetails';
import { extension } from 'mime-types';
import { isEmpty } from 'lodash';
import Dialog from '../../common/Dialog';
import EquipDemandUpdateLine from './EquipDemandUpdateLine';

class DemandChanges extends Component {
    state = {  }
    // componentDidMount = async () => {
    //     if(isEmpty(this.props.LOAN_DEMANDS)){
    //         await this.props.fetchUserLoanDemands()
    //     }
        
    // }
    acceptChanges = async () => {
        const { loan } = this.props;
        let newLoan = Object.assign({}, loan)
        newLoan.user_accept_changes = true
        newLoan.loan_status = "RESA_VALIDATE"
        await this.props.updateResaLoanUser(newLoan)
        // notif success
         // // if NoErrors ...
         if(this.props.STATE.loans.error){
            this.props.notif("error",`Un problème est survenu: ${this.props.STATE.loans.error}`)
        } else { 
            this.props.notif("success", "Changement Accepté")
            this.props.handleClose()
        }
    }
    // handleRefuse = () => {
    //     this.setState({
    //         openChoice : true
    //     })
    // }
    refuseChanges = async () => {
        const { loan } = this.props;
        let newLoan = Object.assign({}, loan)
        newLoan.loan_status = "RESA_CANCELED"
        await this.props.updateResaLoanUser(newLoan)
        // notif success
        if(this.props.STATE.loans.error){
            this.props.notif("error",`Un problème est survenu: ${this.props.STATE.loans.error}`)
        } else { 
            this.props.notif("success", "Changement Refusé")
            this.props.handleClose()
        }
    }

    render() {
        const {loan, demand, equipement } = this.props;
        console.log('====================================');
        console.log({ demand, loan});
        console.log('====================================');
        return (
            <Dialog
                close={this.props.handleClose}
                open={true}
                appBar
                maxWidth="lg"
                title={`Demande du ${new Date(demand.demand_creation_date).toLocaleDateString("fr-FR")} — ${equipement.equipement_original_name}`}
                submitAction={this.acceptChanges}
                submitTitle="Accepter"
                secondSubmitActionButton={this.refuseChanges}
                submitSecondaryTitle="Refuser"
            >
                {/* <Container maxWidth="lg"> */}
                {/* {this.state.openChoice &&
                    <Dialog
                        appBar
                        appBarColor="primary"

                    >
                        <EquipDemandUpdateLine
                            {...this.props}
                        />
                    </Dialog>
                } */}
                    {loan && 
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <Box p={1}>
                                    <Alert severity="error">
                                        <Typography variant="h6"><b>{loan.resa_remarks}</b></Typography>
                                    </Alert>
                                </Box>
                            </Grid>
                            <Grid item container sm={6} xs={12}>
                                <Grid item xs={12}>
                                    <Box p={1} style={{textAlign: "center"}}>
                                        <Typography variant="button" color="primary">
                                            <b>Equipement Réservé</b>
                                        </Typography>
                                    </Box>
                                </Grid>
                                <Grid item xs={12}>
                                    <Box p={1}>Nom: {loan.equipement.equipement_original_name}</Box>
                                    <Box p={1}>Description: {loan.equipement.equipement_desc}</Box>
                                </Grid>
                                {SIDES.map( side =>
                                    <Grid item xs={6}>
                                        <a href={`/photos/single/${loan.equipement[`equipement_photo_${side.name}`].filename}`} 
                                            download={`${side.name}.${ extension(loan.equipement[`equipement_photo_${side.name}`].filetype) || "jpeg"}`}
                                        >
                                            <img 
                                                // style={{opacity: ".7"}}
                                                src={`/photos/single/${loan.equipement[`equipement_photo_${side.name}`].filename}`} 
                                                title={side.name} 
                                                alt={side.name} 
                                            />
                                        </a>
                                    </Grid>
                                )}                                
                            </Grid>
                            
                            <Grid item container sm={6} xs={12} style={{borderLeft:"1px solid lightgray"}}>
                            {/* <Grid item container sm={6} xs={12} style={{borderLeft:"1px solid lightgray"}}> */}
                                <Grid item xs={12}>
                                    <Box p={1} style={{textAlign: "center"}}>
                                        <Typography variant="button" color="primary">
                                            <b>Equipement Demandé</b>
                                        </Typography>
                                    </Box>
                                </Grid>
                                <Grid item xs={12}>
                                    <Box p={1}>Nom: {equipement.equipement_original_name}</Box>
                                    <Box p={1}>Description: {equipement.equipement_desc}</Box>
                                </Grid>
                                {SIDES.map( side =>
                                    <Grid item xs={6}>
                                        <a href={`/photos/single/${equipement[`equipement_photo_${side.name}`].filename}`} 
                                            download={`${side.name}.${ extension(equipement[`equipement_photo_${side.name}`].filetype) || "jpeg"}`}
                                        >
                                            <img 
                                                // style={{opacity: ".7"}}
                                                src={`/photos/single/${equipement[`equipement_photo_${side.name}`].filename}`} 
                                                title={side.name} 
                                                alt={side.name} 
                                            />
                                        </a>
                                    </Grid>
                                )}                                    
                            </Grid>
                        </Grid> 
                    // </>
                    }   
                {/* </Container> */}
            </Dialog>
        );
    }
}

export default DemandChanges;